<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('returnToVendor.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('returnToVendor.pageTitle'),
            href: '/admin/return-to-vendors',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="ts-space-y-3">
            <div class="ts-border ts-p-3 ts-rounded">
              <form class="form-horizontal">
                <div class="row">
                  <div class="col-md-6 ts-space-y-3">
                    <div class="row">
                      <label class="col-md-3 col-form-label required">{{
                        $t('returnToVendor.returnDate')
                      }}</label>
                      <div class="col-md-6">
                        <a-date-picker
                          v-model="model.return_date"
                          format="DD-MM-YYYY"
                          valueFormat="DD-MM-YYYY"
                          class="ts-w-full"
                        ></a-date-picker>
                        <div class="validate" v-if="errors.has('return_date')">
                          {{ errors.first('return_date') }}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label required">{{
                        $t('returnToVendor.vendor')
                      }}</label>
                      <div class="col-md-6">
                        <a-select
                          v-model="model.vendor_id"
                          :options="vendorList"
                          showSearch
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          class="ts-w-full"
                        ></a-select>
                        <div class="validate" v-if="errors.has('vendor_id')">
                          {{ errors.first('vendor_id') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 ts-space-y-3">
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('returnToVendor.remark')
                      }}</label>
                      <div class="col-md-6">
                        <textarea
                          v-model="model.remarks"
                          rows="3"
                          class="form-control"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="ts-border ts-p-3 ts-rounded">
              <Details v-model="model" :validate="errors" />
              <div class="validate" v-if="errors.has('product_detail')">
                {{ errors.first('product_detail') }}
              </div>
            </div>
            <div class="ts-flex ts-justify-end ts-space-x-3">
              <ts-button @click.prevent="$router.push({ name: 'return-to-vendor' })">{{ $t('cancel') }}</ts-button>
              <ts-button color="primary"
								:waiting="waiting"
								@click.prevent="onUpdate"
							>{{ $t('update') }}</ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import moment from 'moment'
import Details from './component/details.vue'
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'returnToVendorEdit',
  components: {
    Details,
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      waiting: false,
      model: {
        return_date: moment().format('DD-MM-YYYY'),
        vendor_id: null,
        remarks: null,
        product_detail: [],
      },
    }
  },
  async created() {
    this.loading = true
    await this.fetchResource()
		await this.find(this.$route.params.id)
      .then(() => this.setEditData())
      .finally(() => (this.loading = false))
  },
  computed: {
		...mapState('stock/returnToVendor', ['edit_data']),
    vendorList() {
      return this.$store.state.stock.returnToVendor.vendor.map((el) => ({
        value: el.vendor_id,
        label: el.vendor_name,
      }))
    },
  },
  methods: {
    ...mapActions('stock/returnToVendor', ['fetchResource', 'update', 'find']),
    onUpdate() {
      this.waiting = true
      this.errors = new Errors()
      this.update({
				id: this.$route.params.id,
				data: this.model
			})
        .then((response) => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'return-to-vendor' })
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
		setEditData(){
			this.model.return_date = this.edit_data.return_date
      this.model.vendor_id = this.edit_data.vendor_id
      this.model.remarks = this.edit_data.remarks
      this.model.product_detail = this.edit_data.details.map(el => ({
					product_id: el.product_id,
					product_name_en: el.product_name_en,
					uom_id: el.uom_id,
					uom_name_en: el.uom_name_en,
					quantity: el.quantity,
          has_serial: el.has_serial, 
					cost: el.cost,
					return_status_id: el.return_status_id,
					stock_in_id: el.stock_in_id,
					stock_in_number: el.stock_in_number,
          pro_group_name_en: el.pro_group_name_en,
					product_type_en: el.product_type_en,
					remarks: el.remarks,
					serials: el.serials.map(el => el.serial_no)
			}))
		}
  },
	beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/returnToVendor/CLEAR_SETUP')
    this.$store.commit('stock/returnToVendor/SET_EDIT_DATA', {})
    next()
  }
}
</script>